import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { WithdrawalRequests } from './WithdrawalRequests/WithdrawalRequests';
import { WithdrawalRequestsContainer } from './WithdrawalRequests/WithdrawalRequests.style';

export const WithdrawalRequestsTab = observer('WithdrawalRequestsTab', () => {
    const appState = useAppStateContext();

    return (
        <WithdrawalRequestsContainer>
            <WithdrawalRequests
                header='Assigned To You'
                type='your'
                withdrawalState={appState.withdrawalState}
            />
            <WithdrawalRequests
                header='Pending Requests'
                type='none'
                withdrawalState={appState.withdrawalState}
            />
            <WithdrawalRequests
                header='Assigned To Others'
                type='other'
                withdrawalState={appState.withdrawalState}
            />
        </WithdrawalRequestsContainer>
    );
});
